declare global {
  interface Window {
    initGoogleMapsCallback?: () => void;
    googleMapsInitialized?: boolean;
  }
}

let initializationPromise: Promise<void> | null = null;

export const loadGoogleMapsScript = async (): Promise<void> => {
  // Return existing promise if initialization is in progress
  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = new Promise(async (resolve, reject) => {
    try {
      // If already initialized, resolve immediately
      if (window.googleMapsInitialized) {
        resolve();
        return;
      }

      // Create a global callback function
      window.initGoogleMapsCallback = () => {
        window.googleMapsInitialized = true;
        resolve();
      };

      // Check if script already exists
      const existingScript = document.querySelector('script[src*="/api/google_maps/script"]');
      if (existingScript) {
        return;
      }

      // Load script directly from our backend proxy (keeps API key secure)
      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.src = '/api/google_maps/script'; // Our backend proxy endpoint
      scriptElement.onerror = () => {
        initializationPromise = null;
        reject(new Error('Failed to load Google Maps script'));
      };
      document.head.appendChild(scriptElement);
    } catch (error) {
      initializationPromise = null;
      reject(error);
    }
  });

  return initializationPromise;
};

export const initializeGoogleMaps = async (): Promise<void> => {
  try {
    await loadGoogleMapsScript();
  } catch (error) {
    console.error('Error loading Google Maps:', error);
    throw error;
  }
}; 